import styled from "styled-components";

import { TABLET_MAX } from "../../styles/breakpoints";

export const BottomNavContainer = styled.div`
  display: none;

  @media (max-width: ${TABLET_MAX}px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 72px;
    padding: 12px 16px;
    gap: 10px;
    background: #edf8fe;
    border-top: 1px solid #ffffff;
    z-index: 1040;
  }
`;

/* Active route pill */
export const ActiveRouteTab = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 4px;
  width: max-content;
  height: 32px;
  background: #ffffff;
  border-radius: 32px;
  flex: none;
  flex-grow: 0;
  cursor: default;
`;

export const RouteIcon = styled.img`
  width: 20px;
  height: 20px;
  flex: none;
`;

export const RouteLabel = styled.span`
  font-family: "Mona Sans", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #2266ef;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

/* Menu pill */
export const MenuButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  width: 88px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #a7c2f9;
  border-radius: 32px;
  cursor: pointer;
  outline: none;
  flex: none;
  flex-grow: 0;

  &:active {
    opacity: 0.8;
  }
`;

export const MenuLabel = styled.span`
  font-family: "Mona Sans", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #000e2a;
  flex: none;
`;

export const QuickActionsButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  gap: 10px;
  width: max-content;
  height: 32px;
  background: #2266ef;
  box-shadow: 0px 4px 25px rgba(34, 102, 239, 0.2);
  border-radius: 32px;
  border: 0;
  color: #ffffff;
  font-family: "Mona Sans", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  cursor: pointer;
  flex: none;
  flex-grow: 0;
  outline: none;

  &:active {
    opacity: 0.8;
  }
`;

export const QuickActionsLabel = styled.span`
  font-family: "Mona Sans", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
`;
